import { Component, Inject, Renderer2, Injectable, RendererFactory2 } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { StorageService } from "./storage.service";
import { Platform } from "@ionic/angular";

@Injectable({
  providedIn: "root"
})
export class UiThemeService {

  public prefersDark: boolean;

  private renderer: Renderer2;
  private matchMedia;

  // eslint-disable-next-line max-len
  constructor(@Inject(DOCUMENT) private document: Document, private storage: StorageService, rendererFactory: RendererFactory2, private platform: Platform) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  async init() {
    const storedTheme = await this.storage.get("theme");
    if (storedTheme === "dark" || storedTheme === "light") {
      this.prefersDark = storedTheme === "dark" ? true : false;
      this.updateTheme();
    } else {
      this.matchMedia = window.matchMedia("(prefers-color-scheme: dark)");
      this.prefersDark = this.matchMedia.matches;
      this.matchMedia.addEventListener("change", (e) => { this.prefersDark = e.matches; this.updateTheme(this.prefersDark); });
      this.updateTheme();

      this.platform.resume.subscribe(async () => {
        this.updateTheme();
      });
    }
  }

  public get(): string {
    if (this.prefersDark) {
      return "dark";
    }
    return "light";
  }

  public updateTheme(prefersDark: boolean = this.prefersDark) {
    switch (prefersDark) {
      case true:
        this.renderer.addClass(document.body, "dark");
        this.storage.set("theme", "dark");
        break;
      case false:
        this.renderer.removeClass(document.body, "dark");
        this.storage.set("theme", "light");
        break;
    }
    this.prefersDark = prefersDark;
  }
}
